import { createContext } from "react";

export const SaleSummaryContext = createContext({});
